import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const CounterElementFields = {
  group: ELEMENT_GROUPS.LAYOUTS,
  label: 'Counter',
  icon: 'ClockIcon',
  description: 'Adds an element that renders a counter',
  properties: [
    'layout',
    'margin',
    'padding',
    {
      label: 'Counter Settings Screen',
      name: 'counterSettingsScreen',
      description:
        'A screen where the counter can be figured by the user. If this is set, a settings/spanner icon will be shown below the counter.',
      editor: 'dropdown',
      options: [],
      function: {
        name: 'getAppScreens',
        values: [],
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Title',
      name: 'text',
      default: '',
      type: 'text',
      description:
        'The title to display above the counter digits. Can accept placeholders.',
      editor: 'textbox',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Sub-Title',
      name: 'subtitle',
      default: '',
      type: 'text',
      description:
        'The title to display above the counter digits. Can accept placeholders.',
      editor: 'textbox',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Title Text Alignment',
      name: 'textAlignment',
      editor: 'alignment',
      description: 'The alignment of the title text',
      default: 'justify-center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Padding',
      name: 'titlePadding',
      editor: 'boundary',
      description: 'Padding around the title',
      default: '0 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Font Size',
      name: 'font',
      default: 14,
      type: 'font',
      description: 'The title font',
      editor: 'fontsize',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Title Font Color',
      name: 'color',
      default: '#000000',
      type: 'font',
      description: 'The title font',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Sub-Title Text Alignment',
      name: 'subtitletextAlignment',
      editor: 'alignment',
      description: 'The alignment of the sub-title text',
      default: 'justify-center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Sub-Title Padding',
      name: 'subtitlePadding',
      editor: 'boundary',
      description: 'Padding around the sub-title',
      default: '0 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Sub-Title Font Size',
      name: 'subtitlefont',
      default: 1,
      type: 'font',
      description: 'The sub-title font',
      editor: 'fontsize',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Sub-Title Font Color',
      name: 'subtitleColor',
      default: '#000000',
      type: 'font',
      description: 'The sib-title font',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Time Elements to Show',
      name: 'timeToShow',
      default: "['D', 'H', 'M', 'S']",
      type: 'text',
      description: "i.e. enter as a JSON array using ['D', 'H', 'M', 'S']",
      editor: 'textbox',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Timer Direction',
      name: 'mode',
      default: 'up',
      type: 'text',
      description: 'Whether to count up or down',
      editor: 'dropdown',
      options: [
        { label: 'Up', value: 'up' },
        { label: 'Down', value: 'down' }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Time Value (Days)',
      name: 'timeValueDays',
      default: 0,
      type: 'number',
      description: 'The number of days to count up to or down from',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Time Value (Hours)',
      name: 'timeValueHours',
      default: 0,
      type: 'number',
      description: 'The number of hours to count up to or down from',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Time Value (Minutes)',
      name: 'timeValueMinutes',
      default: 0,
      type: 'number',
      description: 'The number of minutes to count up to or down from',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Time Value (Seconds)',
      name: 'timeValueSeconds',
      default: 60,
      type: 'number',
      description: 'The number of secinds to count up to or down from',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Counter Background Color',
      name: 'backgroundColor',
      default: '#000000',
      type: 'text',
      description: 'The background color of the timer box',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Counter Pulse Background Color',
      name: 'backgroundColorPulse',
      default: '#000000',
      type: 'text',
      description: 'The background pulse color of the timer box',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Direction Arrows Background Color',
      name: 'directionArrowsBackgroundColor',
      default: '#000000',
      type: 'text',
      description:
        'The background color of the count up/down arrows when not-selected',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Direction Arrows Icon Color',
      name: 'directionArrowsIconColor',
      default: '#ffffff',
      type: 'text',
      description:
        'The icon color of the count up/down arrows when not-selected',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Direction Arrows Selected Background Color',
      name: 'directionArrowsSelectedBackgroundColor',
      default: '#fffff',
      type: 'text',
      description:
        'The background color of the count up/down arrows when not-selected',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Direction Arrows Selected Icon Color',
      name: 'directionArrowsSelectedIconColor',
      default: '#ffffff',
      type: 'text',
      description: 'The icon color of the count up/down arrows when selected',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Counter Border Color',
      name: 'borderColor',
      default: '#000000',
      type: 'text',
      description: 'The border color of the timer box',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Counter Border Width',
      name: 'borderWidth',
      default: '#000000',
      type: 'text',
      description: 'The border width of the timer box',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Counter Border Radius',
      name: 'borderRadius',
      default: '#000000',
      type: 'text',
      description: 'The border radius of the timer box',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Digit Background Color',
      name: 'digitBackgroundColor',
      default: '#000000',
      type: 'text',
      description: 'The background color of each digit',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Digit Text Color',
      name: 'digitTextColor',
      default: '#ffffff',
      type: 'text',
      description: 'The text color of each digit',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Digit Font',
      name: 'digitFont',
      default: 14,
      type: 'text',
      description: 'The font size of each digit',
      editor: 'fontsize',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Time Label Font',
      name: 'timeLabelFont',
      default: 8,
      type: 'text',
      description: 'The font size of the labels that appear below each digit',
      editor: 'fontsize',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Time Label Color',
      name: 'timeLabelColor',
      default: '#000000',
      type: 'text',
      description: 'The text color of the labels that appear below each digit',
      editor: 'color',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Digit Box Height',
      name: 'digitBoxHeight',
      default: 60,
      type: 'text',
      description: 'The height of each digit box',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Digit Box Width',
      name: 'digitBoxWidth',
      default: 60,
      type: 'text',
      description: 'The width of each digit box',
      editor: 'number',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Timer Value Data Source',
      name: 'datasource',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The data source that contains a field that can be used as the value for a timer. If this is a date field, the time element is extracted and converted to seconds.',
      default: '',
      options: [],
      function: {
        name: 'getDataSources',
        params: ['all', false]
      }
    },
    {
      label: 'Timer Value Collection Path',
      name: 'collectionPath',
      editor: 'textbox',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The firestore path to the underlying record of the same type as the data source.',
      default: '',
      options: [],
      function: {
        name: 'getDataSources',
        params: ['all', false]
      }
    },
    {
      label: 'Timer Value Source Field',
      name: 'sourceField',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The field that can be used as the value for a timer. If this is a date field, the time element is extracted and converted to seconds.',
      default: '',
      options: [],
      function: {
        name: 'getDataSourceFields',
        params: ['datasource']
      }
    },
    {
      label: 'Timer Value Duration Field',
      name: 'durationField',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The field that can be used to record the number of seconds elapsed, whenever the counter is stopped or reaches its target number of seconds.',
      default: '',
      options: [],
      function: {
        name: 'getDataSourceFields',
        params: ['datasource']
      }
    },
    {
      label: 'Timer Direction Field',
      name: 'directionField',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'The field that can be used to set the initial direction of the counter.',
      default: '',
      options: [],
      function: {
        name: 'getDataSourceFields',
        params: ['datasource']
      }
    }
  ]
};

export default CounterElementFields;
